/**
 *
 * Asynchronously loads the component for SelectorPage
 *
 */

import { lazyLoad } from 'utils/loadable';

export const SelectorPage = lazyLoad(
  () => import('./index'),
  module => module.SelectorPage,
);
